const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');
import { getLanguage, jsonMerge } from 'core/i18n';

const setInitialState = () => {
    const language = getLanguage();
    const file1 = require(`ok-translations-onboarding/webapp/${language}.json`);
    const file2 = require(`ok-translations-web-shared/webapp/${language}.json`);
    const languageStrings = jsonMerge(file1, file2);
    return Immutable.Map().merge({
        translations: languageStrings,
        error: false,
        isFetching: false,
        completed: false,
    });
};

const reducer = (state = setInitialState(), action) => {
    switch (action.type) {
        case actionTypes.TRANSLATIONS_FETCH_REQUEST:
            return state.merge({
                isFetching: true,
                error: false,
            });

        case actionTypes.TRANSLATIONS_REQUEST_SUCCESS:
            return state.mergeDeep({
                translations: action.translations,
                isFetching: false,
                error: false,
                completed: true,
            });

        case actionTypes.TRANSLATIONS_REQUEST_FAILURE:
            return state.merge({
                error: true,
                isFetching: false,
                completed: true,
            });

        default:
            return state;
    }
};

export default reducer;
